/*
    模块组件
    ChenYN

    说明
    帖子头部

    版本
    1.0

    传参
        user Object : 必填 用户信息
        date String : 必填 日期时间
        topTag String : 非必填 当前这条数据的tag
        views Number : 非必填 阅读数
        type String : 非必填 模式 default = 默认； detail = 详情页（用户昵称加大）; pure = 评论列表模式（纯净模式，就只有头像昵称徽标）
        showDel Boolean : 非必填 是否显示删除按钮
        delFun Function : 非必填 删除按钮事件
        dateType Number : 非必填 日期格式,0就是默认,1是直接返回年月日
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <forum-head :date="forumData.publish_time||forumData.created_at" :achievement="achievement" :delFun="delForum" :showDel="forumData.user.user_id == userInfo.user_id" :user="forumData.user" :topTag="tagTop || (forumData.sub_forum && forumData.sub_forum.name ? forumData.sub_forum.name : '')" :dateType="dateType" :goState="goState"></forum-head>
*/
<template>
    <div class="forum_head">
        <div class="forum_lt">
            <div class="avatar" @click.stop="goStateDetail">
                <img v-if="user.user_avatar" :src="user.user_avatar" alt="" class="avatar_head">
                <img v-else-if="user.avatar" :src="user.avatar" alt="" class="avatar_head">
                <img v-else :src="platform == 'm9377' ? defaultAvatar : platform == 'mengw' ? defaultMengwAvatar : defaultChuangyueAvatar" alt="" class="avatar_head">
                <img v-if="user.user_avatar_frame" :src="user.user_avatar_frame.avatar_frame" alt="" class="avatar_dress">
            </div>

            <div class="user_info">
                <div class="name_level">
                    <div class="name van-ellipsis" :class="[{detail_name: type == 'detail'}, {comment_name: type == 'pure'}]">
                        {{user.nickname || user.username}}
                    </div>
                    <!-- <div class="level" v-if="user.vip_badge">
                        <img :src="user.vip_badge"/>
                    </div>                     -->
                    <div class="badge" v-if="user.is_official==='1'">
                        <!-- <img src="@/assets/images/forum/icon_is_official.png" alt=""/> -->
                        <span>官</span>
                    </div>
                    <div v-if="user.vip" :class="`mine_vip mine_vip_bg_${user.vip}`"></div>
                    <div class="achievementList" v-if="achievement && achievement.length > 0">
                        <div v-for="v in achievement" :key="v.id">
                            <div v-if="v.status == 3 && v.id != 3" :class="`mine_achievement_${v.id}`"></div>
                        </div>
                    </div>
                </div>

                <div class="time_path" v-if="type != 'pure'">
                    <!-- <div class="time" v-if="dateType==1">{{date ? util.timeManage(date) : '00:00'}}</div>
                    <div class="time" v-else>{{date ? util.timeHandle(date) : '00:00'}}</div>
                    <div class="time views" v-if="type == 'detail'">{{views || 0}} 浏览</div>
                    <span v-if="topTag">·</span> -->
                    <div class="path" v-if="topTag">{{topTag || ''}}</div>
                </div>
            </div>
        </div>

        <div class="del_btn" v-if="showDel" @click.stop="deleteFun">删除</div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import Util from '@/assets/js/lib/util';
import router from '@/router';
import defaultAvatar from '@/assets/images/common/avatar_default.png'
import defaultMengwAvatar from '@/assets/images/common/avatar_default_mengw.png'
import defaultChuangyueAvatar from '@/assets/images/common/avatar_default_chuangyue.png'

export default defineComponent({
    name: 'ForumHead',
    props: {
        user: {
            type: Object
        },
        date: {
            type: String,
            default: ''
        },
        topTag: {
            type: String,
            default: ''
        },
        views: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'default'
        },
        showDel: {
            type: Boolean,
            default: false
        },
        delFun: {
            type: Function,
        },
        dateType: {
            type: Number,
        },
        achievement: {
            type: Array,
            default: []
        }
    },
    setup(props) {
        const { forumData, achievement } = toRefs(props);
        const state = reactive({
            util: new Util(),
            defaultAvatar,
            defaultMengwAvatar,
            defaultChuangyueAvatar,
            platform: window.Config.platform
        });
        const deleteFun = () => {
            if(props.delFun){
                props.delFun()
            }
        };
        const methods = {
            goState: (o) => router.push(o),
        }

        const goStateDetail = () =>{
            methods.goState({name:'minedetail',query: {userId:props.user.user_id,time:new Date().getTime()}})
        };

        return {
            ...toRefs(state),
            deleteFun,
            goStateDetail
        };
    },
});
</script>
<style lang="less" scoped>
@import "./ForumHead.less";
</style>
